module.exports = __webpack_public_path__ + "assets/img/cup.a44f41b3.png";